import HtmlParser from "react-html-parser"
import { metadata, SVOD_BLOCK_TEXT } from "lacinetek-common/src/metadata"

export const BlockText = ({ block }) => {
	if (!metadata(block, SVOD_BLOCK_TEXT)) {
		return null
	}

	return HtmlParser(metadata(block, SVOD_BLOCK_TEXT))
}
